module.exports = __webpack_public_path__ + "img/shop7de.7a0fcd9a.png";